export default __webpack_public_path__ + "static/media/mainbg.c31a268d.jpg";